import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

export const FileUploadLabel = ({
  id,
  fileInputRef,
  isRequired,
  isInvalid,
  hasResourceUpdateHighlight,
  removeResourceUpdateHighlight,
  handleFiles,
  UploadIcon,
  disabled,
}) => (
  <label
    id="upload-file-label"
    className={clsx(
      isRequired && 'required',
      isInvalid && 'invalid',
      hasResourceUpdateHighlight && 'updateHighlight'
    )}
    htmlFor={id}
    onClick={removeResourceUpdateHighlight}
  >
    <input
      id={id}
      ref={fileInputRef}
      type="file"
      accept="image/*"
      disabled={disabled}
      data-testid="upload-image-button"
      onChange={({ target }) => {
        handleFiles(target.files);
        // Clear the file input so the same file can be uploaded again if needed
        target.value = '';
      }}
    />
    <UploadIcon />
    <p>Upload Image</p>
  </label>
);

FileUploadLabel.propTypes = {
  id: PropTypes.string.isRequired,
  fileInputRef: PropTypes.object.isRequired,
  isRequired: PropTypes.bool,
  isInvalid: PropTypes.bool,
  hasResourceUpdateHighlight: PropTypes.bool,
  removeResourceUpdateHighlight: PropTypes.func,
  handleFiles: PropTypes.func,
  UploadIcon: PropTypes.elementType.isRequired,
  disabled: PropTypes.bool,
};

FileUploadLabel.defaultProps = {
  isRequired: false,
  isInvalid: false,
  hasResourceUpdateHighlight: false,
  removeResourceUpdateHighlight: () => {},
  handleFiles: () => {},
  disabled: false,
};

